import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import CasinoList from '../components/CasinoList';
import Footer from '../components/Footer';

function Home() {
  const [wowInitialized, setWowInitialized] = useState(false);

  useEffect(() => {
    // Load and initialize WOW.js animations
    const loadWOW = () => {
      if (window.WOW) {
        new window.WOW().init();
        setWowInitialized(true);
      } else {
        // Load WOW.js if not already loaded
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js';
        script.integrity = 'sha512-Eak/29OTpb36LLo2r47IpVzPBLXnAMPAVypbSZiZ4Qkf8p/7S/XRG5xp7OKWPPYfJT6metI+IORkR5G8F900+g==';
        script.crossOrigin = 'anonymous';
        script.referrerPolicy = 'no-referrer';
        script.onload = () => {
          if (window.WOW) {
            new window.WOW().init();
            setWowInitialized(true);
          }
        };
        document.head.appendChild(script);
      }
    };

    loadWOW();
  }, []);

  // Reinitialize WOW.js when content changes (for dynamic content)
  useEffect(() => {
    if (wowInitialized && window.WOW) {
      // Small delay to ensure DOM is updated
      setTimeout(() => {
        new window.WOW().init();
      }, 100);
    }
  }, [wowInitialized]);

  return (
    <div className="App">
      <Header />
      <Hero />
      <CasinoList />
      <Footer />
    </div>
  );
}

export default Home;

